












































































































import {
  Component, Vue, Prop, PropSync,
} from 'vue-property-decorator';

import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';

import numberFormat from '@/libs/numberFormat';
import dayjs from 'dayjs';

@Component({
  components: {
    LayoutContent,
    Button,
  },
  methods: {
    numberFormat,
  },
})

export default class MerchantBillingSummary extends Vue {
  /* eslint-disable */
  numberFormat!: typeof numberFormat;
  loadingExport = false;

  submitData(item: any) {
    let data: any = { ...item };
    let listPeriode: any[] = [];
    item.merchant_traffic.forEach((val: any) => {
      listPeriode.push({ credential_code: val.credential_code, periode: val.periode, periode_slug: val.periode_slug })
    })
    let summaryData: any = {
      totalTraffic: numberFormat(this.sumTotal('traffic', item)),
      pricePerTransaction: this.displayPrice(item),
      totalBilling: numberFormat(this.sumTotal('billing', item), true, false),
      listPeriode,
    };
    Vue.set(data, 'isSinglePeriod', this.isSinglePeriod);
    Vue.set(data, 'summaryData', summaryData);
    // if (this.isSinglePeriod) {
    //   // console.log('single period', this.trafficPerDay, item);
    //   Vue.set(data, 'trafficPerDay', this.trafficPerDay);
    // }
    this.$emit('confirmClick', data);
  }

  get isSinglePeriod() {
    try {
      if (this.selectedPeriod.length === 1) {
        if (this.selectedPeriod[0].merchant_traffic.length === 1) {
          return true;
        }
      }
      return false;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  sumTotal(type: string, itemData: any = {}) {
    try {
      switch (type) {
        case "traffic": {
          let totalTraffic: number = 0;
          if (this.isSinglePeriod) {
            if (this.trafficPerDay) {
              this.trafficPerDay.forEach((val: any) => {
                totalTraffic += parseInt(val.merchant_traffic || 0);
              })
            }
          } else {
            itemData.merchant_traffic.forEach((val: any) => {
              totalTraffic += parseInt(val.total_traffic || 0);
            })
          }
          return totalTraffic;
        }
        case "merchant_amount": {
          let totalAmount: number = 0;
          if (this.isSinglePeriod) {
            if (this.trafficPerDay) {
              this.trafficPerDay.forEach((val: any) => {
                totalAmount += parseFloat(val.merchant_amount || 0);
              })
            }
          } else {
            itemData.merchant_traffic.forEach((val: any) => {
              totalAmount += parseFloat(val.total_amount || 0);
            })
          }
          return totalAmount;
        }
        case "billing": {
          let totalBilling: number = 0;
          if (this.isSinglePeriod) {
            if (this.trafficPerDay) {
              const price: any = this.getPrice(itemData || []);
              this.trafficPerDay.forEach((val: any) => {
                switch (this.getBillType(itemData)) {
                  case "normal":
                  case "tiring": {
                    totalBilling += (parseInt(val.merchant_traffic || 0) * parseFloat(price[0] || 0));
                    break;
                  }
                  case "mdr": {
                    totalBilling += (parseFloat(val.merchant_amount || 0) * parseFloat(price[0] || 0));
                    break;
                  }
                  case "mixed": {
                    totalBilling += (parseInt(val.merchant_traffic || 0) * parseFloat(price[0] || 0)) +
                      (parseFloat(val.merchant_amount || 0) * parseFloat(price[1] || 0));
                    break;
                  }
                  case "tiring_amount": {
                    if (price[1] === 'normal') {
                      totalBilling += (parseInt(val.merchant_traffic || 0) * parseFloat(price[0] || 0));
                    } else if (price[1] === 'mdr') {
                      totalBilling += (parseFloat(val.merchant_amount || 0) * parseFloat(price[0] || 0));
                    }
                    break;
                  }
                }
              })
            }
          } else {
            itemData.merchant_traffic.forEach((val: any) => {
              totalBilling += parseFloat(val.total_bill);
            })
          }
          return totalBilling;
        }
      }
    } catch (error) {
      console.log(error);
      return 0;
    }
  }

  cancelDisclaimClick() {
    try {
      this.syncedMerchantDisclaim = false;
      this.$emit('cancelDisclaimClick');
    } catch (error) {
      console.log(error);
    }
  }

  exportData(itemData: any) {
    const periode_slug = itemData.merchant_traffic.map((val: any) => val.periode_slug)
    const periode_name: string = itemData.merchant_traffic.map((val: any) => val.periode).join()
    const params: any = {
      credential: itemData.merchant_traffic[0].credential_code,
      periode: JSON.stringify(periode_slug),
    }
    this.$emit(
      'exportClick',
      params,
      `Rekonsialiasi Report ${itemData.service_name.toString().trim()} ${itemData.brand_name.toString().trim()}_${periode_name}.xlsx`
    );
  }

  isActivePeriod(itemData: any) {
    try {
      // console.log('date', dayjs().add(-1, 'month').format("YYYYMM"), dayjs().get('date'));
      let hasActive = false;
      const currentPeriod = dayjs().format("YYYYMM");
      const previousPeriod = dayjs().add(-1, 'month').format("YYYYMM");
      itemData.merchant_traffic.forEach((data: any) => {
        if (
          (data.periode_slug === currentPeriod) ||
          (data.periode_slug === previousPeriod && dayjs().get('date') < this.dateActivePeriod)
        ) {
          hasActive = true;
        }
      })
      return hasActive;
    } catch (error) {
      console.log(error);
      return true;
    }
  }

  disableSubmit(itemData: any) {
    try {
      if (/normal|tiring/.test(this.getBillType(itemData))) {
        for (const data of (this.trafficPerDay || [])) {
          if (data.merchant_traffic != data.sprint_traffic) {
            return false;
          }
        }
        return true;
      } else {
        let allSame = true;
        for (const data of (this.trafficPerDay || [])) {
          if (data.merchant_traffic != data.sprint_traffic) {
            if (data.merchant_amount == data.amount) {
              return true;
            }
            allSame = false;
          } else {
            if (data.merchant_amount != data.amount) {
              return true;
            }
          }
        }
        return allSame;
      }
    } catch (error) {
      console.log(error);
      return true;
    }
  }

  getBillType(itemData: any) {
    try {
      let multiple_billType = JSON.parse(itemData.multiple_billType || "[]");
      if (multiple_billType.length > 1) {
        return 'mixed';
      } else if (multiple_billType.length > 0) {
        return multiple_billType[0].type;
      } else {
        return itemData.billType;
      };
    } catch (error) {
      console.log(error);
      return '';
    }
  }

  getPrice(itemData: any) {
    try {
      let multiple_billType = JSON.parse(itemData.multiple_billType || "[]");
      if (multiple_billType.length > 0) {
        switch (this.getBillType(itemData)) {
          case 'normal':
          case 'mdr':
          case 'mixed': {
            return multiple_billType.map((val: any) => val.price);
          }
          case 'tiring': {
            let tiringPrice = multiple_billType[0].price || [];
            const totalTraffic = this.sumTotal('traffic', itemData) || 0;
            if (tiringPrice.length > 0) {
              for (const data of tiringPrice) {
                if (parseInt(data.traffic_min) <= totalTraffic && totalTraffic <= parseInt(data.traffic)) {
                  return [data.price]
                }
              };
            }
          }
          case 'tiring_amount': {
            let tiringPrice = multiple_billType[0].price || [];
            const totalAmount = this.sumTotal('merchant_amount', itemData) || 0;
            if (tiringPrice.length > 0) {
              for (const data of tiringPrice) {
                if (parseInt(data.traffic_min) <= totalAmount && totalAmount <= parseInt(data.traffic)) {
                  return [data.price, data.type]
                }
              };
            }
          }
        }
      } else {
        return [itemData.price_per_transaction];
      }
      return []
    } catch (error) {
      console.log(error);
      return []
    }
  }

  displayPrice(itemData: any) {
    switch (this.getBillType(itemData)) {
      case 'normal': {
        return numberFormat(this.getPrice(itemData)[0], true);
      }
      case 'mdr': {
        return `${numberFormat((this.getPrice(itemData)[0] || 0) * 100)}%`
      }
      case 'mixed': {
        const listPrice = this.getPrice(itemData) || []
        return `${numberFormat(listPrice[0], true)} & ${numberFormat((listPrice[1] || 0) * 100)}%`;
      }
      case 'tiring': {
        return numberFormat(this.getPrice(itemData)[0], true)
      }
      case 'tiring_amount': {
        const listPrice = this.getPrice(itemData) || []
        return listPrice[1] === 'normal' ?
          numberFormat(this.getPrice(itemData)[0], true) :
          listPrice[1] === 'mdr' ? `${numberFormat((this.getPrice(itemData)[0] || 0) * 100)}%` : "-";
      }
    }
  }

  get dateActivePeriod() {
    return parseInt(process.env.VUE_APP_RECON_DATE_ACTIVE_PERIOD || '5');
  }

  @PropSync('merchantDisclaim', { type: Boolean }) syncedMerchantDisclaim!: boolean;
  @Prop() readonly selectedPeriod!: any[];
  @Prop() readonly trafficPerDay!: any;
}
